<template>
    <el-row>
        <table-template :queryParams="queryParams" actionUrl="/friend/findFriendCircleList.action"
                        ref="searchcarTable">
            <template slot="search">
                <el-select  @change="$refs['searchcarTable'].search()" clearable placeholder="置顶状态" style="margin-left:5px;"
                            v-model="queryParams.sortTimeType">
                    <el-option :value="1" label="置顶中"></el-option>
                    <el-option :value="2" label="未置顶"></el-option>
                </el-select>

                <el-select  @change="$refs['searchcarTable'].search()" clearable placeholder="回复状态" style="margin-left:5px;"
                            v-model="queryParams.replyStatus">
                    <el-option :value="1" label="有回复"></el-option>
                    <el-option :value="2" label="未回复"></el-option>
                </el-select>

                <el-date-picker
                        style="margin-left:10px;"
                        v-model="queryParams.startEndTime"
                        @change="onDateTimeChange"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
                <el-input v-model="queryParams.keyword1" style="margin-left:10px;width:200px;" placeholder="地区/设备号"></el-input>
              <el-input v-model="queryParams.keyword" style="margin-left:10px;width:200px;" placeholder="内容/手机号/微信号"></el-input>

              <el-button style="margin-left:10px;" type="primary" @click="$refs['searchcarTable'].search()">搜索</el-button>

                <el-button style="margin-left:10px;" type="primary" @click="showSettingFriend">设置朋友圈客服</el-button>
            </template>

            <template slot="item">
                <el-table-column
                        label="昵称"
                        prop="name">
                </el-table-column>

                <el-table-column
                    label="联系电话"
                    prop="phone">
              </el-table-column>

                <el-table-column
                        label="微信号"
                        prop="wechat">
                </el-table-column>
                <el-table-column
                        label="内容"
                        prop="content" width="200px;">
                </el-table-column>

                <el-table-column
                    label="图片"
                    prop="content" width="300px">

                <template scope="scope">
                    <img :src="imgUrl"  v-for="imgUrl in scope.row.imgs"  style="width: 80px;height: 80px;margin-left: 10px;">
                </template>

            </el-table-column>
                <el-table-column
                        label="视频"
                        prop="content" width="250px">
                    <template scope="scope">
                       <!-- <el-button   type="text" v-if="scope.row.videoUrl"   @click.native.prevent="$router.push({path:'/home/friendVideo', query:{'videoUrl':scope.row.videoUrl}})">查看视频
                        </el-button>-->
                        <video v-if="scope.row.videoUrl" width="200" height="200" controls>
                            <source :src="scope.row.videoUrl" type="video/mp4">
                        </video>
                    </template>

                </el-table-column>
              <el-table-column
                  label="地区"
                  prop="city">
              </el-table-column>
              <el-table-column
                  label="设备号"
                  prop="deviceName">
              </el-table-column>
                <el-table-column
                        label="创建时间"
                        prop="createTime" width="230px">
                    <template scope="scope">
                       <p>创建时间：{{scope.row.createTime | dateTimeFormat}}</p>
                        <p v-if="scope.row.sortTime != null && scope.row.sortTime > currentTime">置顶结束：{{scope.row.sortTime|dateTimeFormat}}</p>
                        <p>浏览量： {{scope.row.browseCount }} </p>
                        <p>拨打量：{{scope.row.businessBrowseCount}}</p>
                        <p>回复数： {{scope.row.replyCount }}</p>

                    </template>
                </el-table-column>

                <el-table-column
                        label="操作">
                    <template scope="scope">

                        <el-button :confirm-data="{id:scope.row.id}"  @onConfirm="$refs['searchcarTable'].search()"
                                   :confirm-text="'删除朋友圈'" requestUrl="friend/delFriend.action"
                                   type="text"
                                   v-confirm>删除朋友圈
                        </el-button>
                      <el-button :confirm-data="{wechat:scope.row.wechat,deviceName:scope.row.deviceName}"  @onConfirm="$refs['searchcarTable'].search()"
                                   :confirm-text="'解绑关系'" requestUrl="businessIntranet/unBindWechatDevice.action"
                                   type="text"
                                   v-confirm>解绑关系
                        </el-button>
                      <el-button  type="text" @click="$router.push({path:'/home/editFriend', query: { id: scope.row.id }})">编辑</el-button>
                    </template>
                </el-table-column>
            </template>
        </table-template>
        <el-dialog :visible.sync="settingFriendDialog" title="设置朋友圈客服二维码" width="40%">
            <el-form :model="settingFriendForm" @onEdited="onQrEdited" @onAdded="onQrEdited"
                     class="demo-ruleForm" addAction="businessIntranet/settingFriend.action"  editAction="businessIntranet/settingFriend.action" label-width="50px"
                     ref="ruleForm"
                     v-form>

                <el-form-item prop="qr">

                    <el-upload
                            :action="baseUrl+'upload/uploadPic'"
                            :data="{floder:'friendList'}"
                            :show-file-list="false"
                            class="avatar-uploader"
                            v-model="settingFriendForm.friendCustomerServiceImg">
                        <img :src="settingFriendForm.friendCustomerServiceImg.url"
                             class="avatar" v-if="settingFriendForm.friendCustomerServiceImg && settingFriendForm.friendCustomerServiceImg.url">
                        <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                    </el-upload>
                    <div style="color:#999;">点击图片 添加/修改</div>
                </el-form-item>

                <el-form-item label="到期会员是否同步" label-width="170px">
                    <el-radio-group v-model="settingFriendForm.synFriend">
                        <el-radio :label="'1'">同步</el-radio>
                        <el-radio  :label="'2'">不同步</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item>
                    <el-button @click="settingFriendDialog = false">取 消</el-button>
                    <el-button type="primary">确 定</el-button>
                </el-form-item>
            </el-form>

        </el-dialog>
    </el-row>

</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'
import Config from '@/framework/configs/Config'
import BasicModel from '@/framework/basic/BasicModel'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'friendList',
  data: function () {
    return {
      baseUrl: Config.baseUrl,
      baseImageUrl: Config.imageUrl,
      settingFriendDialog: false,
      friendCustomerService: null,
      currentTime: new Date().getTime(),
      settingFriendForm: {
        id: null,
        friendCustomerServiceImg: null,
        synFriend: 1
      },
      queryParams: {
        startTime: null,
        endTime: null,
        keyword: null,
        keyword1: null,
        sortTimeType: null,
        replyStatus: null
      }
    }
  },
  methods: {

    showSettingFriend: function () {
      let _this = this
      let listener = {
        success: function (dataInfo) {
          if (dataInfo.datas) {
            _this.settingFriendForm.friendCustomerServiceImg = { url: _this.baseImageUrl + dataInfo.datas.friendCustomerServiceImg }
            _this.settingFriendForm.synFriend = dataInfo.datas.synFriend
          }
        }
      }
      BasicModel.get(this, 'businessIntranet/getSettingFriend.action', this.queryParams, listener)

      this.settingFriendDialog = true
    },
    onQrEdited: function () {
      this.$message({
        message: '微信客服二维码提交成功！',
        type: 'success'
      })
      this.settingFriendDialog = false
    },
    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
      this.$refs.searchcarTable.search()
    },
    onStatusChange: function (value) {
      this.queryParams.status = value
      this.$refs['searchcarTable'].search()
    }
  },
  filters: {

  }
}
</script>

<style scoped>

</style>
